export default __webpack_public_path__ + "static/media/chaise.5c953898.webp";